"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ajax = void 0;
var ajax;
(function (ajax) {
    /**
    * GET送信
    * @param url
    * @param responseType
    * @param onSuccess
    * @param onRedirection
    * @param onClientError
    * @param onServerError
    */
    function get(url, addHeaders, responseType, onSuccess, onRedirection, onClientError, onServerError) {
        if (responseType === void 0) { responseType = "json"; }
        if (onSuccess === void 0) { onSuccess = null; }
        if (onRedirection === void 0) { onRedirection = null; }
        if (onClientError === void 0) { onClientError = null; }
        if (onServerError === void 0) { onServerError = null; }
        var req = new XMLHttpRequest();
        req.onreadystatechange = function () {
            finishProc(req, onSuccess, onRedirection, onClientError, onServerError, responseType);
        };
        req.open('GET', url, true);
        req.responseType = responseType;
        for (var i = 0; i < addHeaders.length; i++) {
            req.setRequestHeader(addHeaders[i].key, addHeaders[i].value);
        }
        req.send(null);
    }
    ajax.get = get;
    /**
    * POST送信
    * @param url
    * @param data
    * @param responseType
    * @param onSuccess
    * @param onRedirection
    * @param onClientError
    * @param onServerError
    */
    function post(url, addHeaders, data, responseType, onSuccess, onRedirection, onClientError, onServerError, isForm) {
        if (responseType === void 0) { responseType = "json"; }
        if (onSuccess === void 0) { onSuccess = null; }
        if (onRedirection === void 0) { onRedirection = null; }
        if (onClientError === void 0) { onClientError = null; }
        if (onServerError === void 0) { onServerError = null; }
        if (isForm === void 0) { isForm = false; }
        var req = new XMLHttpRequest();
        req.onreadystatechange = function () {
            finishProc(req, onSuccess, onRedirection, onClientError, onServerError, responseType);
        };
        req.open('POST', url, true);
        req.responseType = responseType;
        for (var i = 0; i < addHeaders.length; i++) {
            req.setRequestHeader(addHeaders[i].key, addHeaders[i].value);
        }
        if (!isForm)
            req.setRequestHeader("Content-Type", "application/json");
        //else req.setRequestHeader("Content-Type", "multipart/form-data");
        req.send(data);
    }
    ajax.post = post;
    function put(url, addHeaders, data, responseType, onSuccess, onRedirection, onClientError, onServerError) {
        if (responseType === void 0) { responseType = "json"; }
        if (onSuccess === void 0) { onSuccess = null; }
        if (onRedirection === void 0) { onRedirection = null; }
        if (onClientError === void 0) { onClientError = null; }
        if (onServerError === void 0) { onServerError = null; }
        var req = new XMLHttpRequest();
        req.onreadystatechange = function () {
            finishProc(req, onSuccess, onRedirection, onClientError, onServerError, responseType);
        };
        req.open('put', url, true);
        req.responseType = responseType;
        for (var i = 0; i < addHeaders.length; i++) {
            req.setRequestHeader(addHeaders[i].key, addHeaders[i].value);
        }
        req.setRequestHeader("Content-Type", "application/json");
        req.send(data);
    }
    ajax.put = put;
    function del(url, addHeaders, data, responseType, onSuccess, onRedirection, onClientError, onServerError) {
        if (responseType === void 0) { responseType = "json"; }
        if (onSuccess === void 0) { onSuccess = null; }
        if (onRedirection === void 0) { onRedirection = null; }
        if (onClientError === void 0) { onClientError = null; }
        if (onServerError === void 0) { onServerError = null; }
        var req = new XMLHttpRequest();
        req.onreadystatechange = function () {
            finishProc(req, onSuccess, onRedirection, onClientError, onServerError, responseType);
        };
        req.open('DELETE', url, true);
        req.responseType = responseType;
        for (var i = 0; i < addHeaders.length; i++) {
            req.setRequestHeader(addHeaders[i].key, addHeaders[i].value);
        }
        req.setRequestHeader("Content-Type", "application/json");
        req.send(data);
    }
    ajax.del = del;
    /**
    * レスポンス結果への共通処理
    * @param req
    * @param onSuccess
    * @param onRedirection
    * @param onClientError
    * @param onServerError
    */
    function finishProc(req, onSuccess, onRedirection, onClientError, onServerError, responseType) {
        if (onSuccess === void 0) { onSuccess = null; }
        if (onRedirection === void 0) { onRedirection = null; }
        if (onClientError === void 0) { onClientError = null; }
        if (onServerError === void 0) { onServerError = null; }
        if (req.readyState == 4) {
            var res = req.response;
            // IEではresponseTypeにJSONを受付けない
            if (responseType == "json" && typeof req.response !== "object") {
                res = JSON.parse(req.response);
                if (typeof res !== "object") {
                    res = JSON.parse(res);
                }
            }
            // 通信完了
            if (200 <= req.status && req.status < 300) {
                // 2xx: Success (成功)
                if (onSuccess != null)
                    onSuccess(req, res);
            }
            else if (300 <= req.status && req.status < 400) {
                // 3xx: Redirection (転送)
                if (onRedirection != null)
                    onRedirection(req, res);
            }
            else if (400 <= req.status && req.status < 500) {
                // 4xx: Client Error (クライアントエラー)
                if (onClientError != null)
                    onClientError(req, res);
            }
            else if (500 <= req.status && req.status < 600) {
                // 5xx: Server Error (サーバエラー)
                if (onServerError != null)
                    onServerError(req, res);
            }
            else {
                // 例外：クライエントエラーとする
                if (onClientError != null)
                    onClientError(req, res);
            }
        }
        else {
            // 通信中
        }
    }
    ajax.finishProc = finishProc;
})(ajax = exports.ajax || (exports.ajax = {}));
